<template>
  <chart :data="data" />
</template>
<script>
import Chart from '../Chart'

export default {
  components: {
    Chart,
  },
  props: ['data'],
  data() {
    return {
      value: 'water',
      chartValues: {
        water: { title: 'Vodné', decimal: 2, suffix: 'm3' },
        sewerage: { title: 'Stočné', decimal: 2, suffix: 'm3' },
        rainfall: { title: 'Zrážky', decimal: 2, suffix: 'm3' },
        totalPrice: { title: 'Celková cena', decimal: 2, suffix: '€ bez dph' },
      },
    }
  },
  computed: {
    monthlySeries() {
      let data = []
      data = this.data.filter((item) => {
        return !item.total
      })
      return data.map((item, k) => {
        return {
          name: item.year,
          type: 'column',
          visible: k <= 2,
          data: item.data.map((val) => {
            switch (this.value) {
              case 'water':
                return val.water
              case 'sewerage':
                return val.sewerage
              case 'rainfall':
                return val.rainfall
              case 'totalPrice':
                return val.totalPrice
            }
          }),
        }
      })
    },
    yearlySeries() {
      return this.data.map((item) => {
        return item.data.reduce((sum, item) => {
          switch (this.value) {
            case 'water':
              return sum + item.water
            case 'sewerage':
              return sum + item.sewerage
            case 'rainfall':
              return sum + item.rainfall
            case 'totalPrice':
              return sum + item.totalPrice
          }
        }, 0)
      })
    },
  },
}
</script>
